export enum RadiationControlCodes {
  BASIC_INFO = 'radiation_basic_info',
  PAGE_RATING = 'radiation_page_rating',
  OVERVIEW = 'radiation_overview',
  WHAT_NEXT = 'radiation_what_next',
  SIDE_EFFECT = 'radiation_possible_side_effect',
  RELATED_TOPICS = 'radiation_related_topics',
  TAGS = 'radiation_tags',
}
